import { company_name } from "@/i18n/variables";

const configurator = {
	backup: {
		description: `<strong>Standaard back-up</strong> 
			<ul>
				<li>Een dagelijkse back-up die 2 dagen wordt bewaard.</li>
				<li>Een wekelijkse back-up die 2 weken wordt bewaard.</li>
				<li>Een maandelijkse back-up die 1 maand wordt bewaard.</li>
			</ul>
			
			<strong>Extra back-up</strong> 
			<ul>
				<li>4x per dag een back-up waarvan er één 7 dagen wordt bewaard.</li>
				<li>Een wekelijkse back-up die 4 weken wordt bewaard.</li>
				<li>Een maandelijkse back-up die 6 maanden wordt bewaard.</li>
			</ul>`,
		radio: {
			extra_backups: {
				label: "Extra back-ups",
				tip: "Er wordt 4x per dag een back-up gemaakt. Één dagelijkse wordt 7 dagen bewaard, één wekelijkse 4 weken en één maandelijkse 6 maanden.",
			},
			standard: {
				label: "Standaard",
				tip: "<Er wordt 1x per dag een back-up gemaakt, die we 2 dagen bewaren. Één wekelijkse back-up wordt 2 weken bewaard en één maandelijkse back-up 1 maand.",
			},
		},
		title: "Back-up",
	},
	config_lower_then_template:
		"Het ingestelde {{label}} is {{configuration_value}} {{unit_type}}, terwijl het besturingssysteem minimaal {{template_value}} {{unit_type}} aanbeveelt. Dit kan leiden tot prestatieproblemen.",
	configurator_overview: {
		cancel_concept_order_error:
			"We konden de concept order niet annuleren. Probeer het later opnieuw.",
		change_vps: "Uw VPS wijzigen",
		confirm_new_vps: "Overzicht nieuwe VPS",
		excl_vat: "Excl. BTW",
		form: {
			description: {
				label: "VPS omschrijving",
				placeholder: "Opmerkingen/bijzonderheden VPS",
			},
			name: {
				label: "VPS naam",
				placeholder: "",
			},
			purchase_order_number: {
				label: "Uw inkoopordernummer",
				placeholder: "Uw eventuele inkoopordernummer",
			},
		},
		info: "Het dataverkeer van uw nieuwe VPS zal binnen uw account pool worden berekend. Ga voor meer informatie naar",
		license: "Licentie",
		new_price: "Prijs nieuwe configuratie",
		new_vps: "Besturingssysteem/toepassing",
		old_price: "U betaalde",
		price_total: "Totaalprijs",
		vps_configuration: {
			description: "Overzicht van uw nieuwe VPS.",
			title: "VPS configuratie",
		},
		vps_details: {
			description: "Indien nodig kunt u dit hier nog wijzigen.",
			title: "VPS details",
		},
		your_discount: "Uw korting",
		your_vps: "Besturingssysteem/toepassing",
	},
	details: {
		description:
			"Geef de VPS een duidelijke naam (geen speciale tekens). U kunt optioneel een omschrijving toevoegen aan de VPS.",
		inputs: {
			description: "VPS omschrijving",
			name: "VPS naam",
		},
		title: "VPS naam",
	},
	extra_storage: {
		bulk_storage: {
			description:
				"Deze storage is uitermate geschikt voor back-up data, archivering en gegevens voor niet-kritieke diensten. Van deze storage worden <strong>geen back-ups </strong> gemaakt.",
			title: "Bulk",
		},
		description:
			"Hier kan extra opslag toegevoegd worden aan de VPS voor verschillende doeleinden. \n Vink de gewenste opslag aan.",
		no_storage: "Geen opslag",
		performance_storage: {
			description: "Hier moet nog een text voor worden verzonnen!!! T.B.D",
			title: "Performance",
		},
		title: "Extra opslag",
	},
	footer: {
		actual_price: "Actuele prijs",
		configuration_check: "Configuratie controleren",
		configuration_price: "Configuratie prijs",
		discount_price: "Uw prijs",
		month: "Maand",
		order_title: "Bestellen",
	},
	internet: {
		description: {
			href: "https://www.tuxis.nl/netwerk",
			text: "Maak een keuze tussen <strong>IPv6</strong> of <strong>IPv4 & IPv6</strong>.<br/>Alleen verkeer dat het Tuxis-netwerk verlaat, wordt uit uw netwerk-pool gehaald. Nog geen pool gekozen? Dan hanteren wij optie één: 100 GB zoals vermeld op <a>tuxis.nl/netwerk</a>.",
		},
		radio: {
			ipv4: "Met een IPv4- en IPv6-adres",
			ipv6: "Met alleen een IPv6-adres",
			no_internet: "Geen internetverbinding",
		},
		title: "Internet verbinding",
	},
	private_networks: {
		description:
			"Koppel VPS'en aan elkaar middels een private network. De VPS krijgt hiervoor een aparte netwerk interface. VPS'en die in hetzelfde netwerk staan kunnen met elkaar communiceren. U hoeft alleen IP-adressen te configureren op deze interne interface. ",
		existing: {
			select: {
				label: "Private network",
				list: "Selecteer een netwerk",
			},
			title: "Selecteer een bestaand private network",
		},
		new: {
			input: {
				description: "Netwerk omschrijving",
				name: "Netwerk naam",
			},
			title: "Nieuw private network",
		},
		radio: {
			existing_private_network: "Bestaand private network",
			new_private_network: "Nieuw private network",
			no_private_network: {
				label: "Geen private network",
				tip: "De VPS wordt geleverd met een internetinterface voor toegang tot het internet.",
			},
		},
		title: "Private networks",
	},
	sla: {
		description: {
			href: "https://tuxis.nl/sla",
			text: "Maak van uw VPS een fully managed vps. Een SLA - level 1 monitort 24x7 de systeemgezondheid en een SLA - level 2 zelfs of uw applicatie reageert. Een half uur arbeid is aan deze VPS is inbegrepen en u kunt rekenen op gegarandeerde responstijden. Zie <a>tuxis.nl/sla</a> voor de volledige SLA.",
		},
		radio: {
			level_one: {
				label: "SLA - level 1",
				tip: `<strong>SLA - level 1</strong> 
					<ul>
						<li>Monitoring systeemgezondheid</li>
						<li>Binnen één uur wordt begonnen met het verhelpen van storingen</li>
						<li>1x per maand updates draaien</li>
						<li>Belangrijke security updates direct</li>
						<li>Half uur arbeid aan deze VPS</li>
						<li>24×7 ingrijpen bij storingen</li>
					</ul>
				`,
			},
			level_two: {
				label: "SLA - level 2",
				tip: `<strong>SLA - level 2</strong> 
					<ul>
						<li>Monitoring systeemgezondheid</li>
						<li>Binnen één uur wordt begonnen met het verhelpen van storingen</li>
						<li>1x per maand updates draaien</li>
						<li>Belangrijke security updates direct</li>
						<li>Half uur arbeid aan deze VPS</li>
						<li>Monitoring van services en resultaat</li>
						<li>24×7 ingrijpen bij storingen of uitval services</li>
					</ul>
				`,
			},
			level_zero: {
				label: "SLA - Level 0",
			},
			no_sla: "Geen",
		},
		title: "Service Level Agreement",
	},
	snapshots: {
		description:
			"Snapshots zijn handig om te maken wanneer u een update gaat doen. U bepaalt hier hoeveel u er tegelijk mag bewaren.",
		no_snapshots: {
			info: "U kunt deze alleen kiezen als <strong>alle </strong>snapshots zijn opgeruimd.",
			label: "Geen",
		},
		select_amount: {
			info: "Er {{are}} momenteel <strong>{{snapshots}} {{multiple}}</strong> gemaakt. U kunt dus maximaal afschalen tot <strong>{{snapshots}} {{multiple}}</strong>.",
			label: "Snapshots",
		},
		title: "Snapshots",
	},
	specs: {
		cpu: {
			title: "CPU cores",
		},
		info: "Voor grotere configuraties, neem contact met ons op.",
		license: "<span>Licentie:</span> €{{price}} p/m",
		ram: {
			title: "Werkgeheugen",
		},
		ssd: {
			title: "SSD-opslag",
			tooltip:
				"Uw data wordt realtime weggeschreven in drie datacenters op SSD's. Hoe meer CPU cores u in de VPS stopt, hoe hoger het aantal IOPS. LINK op IOPS naar https://support.tuxis.nl/nl/knowledgebase/article/iops-vps.",
		},
		title: "VPS capaciteit",
	},
	ssh: {
		add_engineer_keys: {
			no: "Nee",
			title: `Wilt u ${company_name} toegang geven tot uw VPS middels SSH?`,
			yes: "Ja, geef toegang",
		},
		add_own_keys: {
			no: "Nee",
			success: "SSH-key toegevoegd aan uw account",
			title: "Wilt u uw persoonlijke public SSH-key(s) gebruiken?",
			yes: "Ja",
		},
		already_present:
			"SSH-key niet toegevoegd: De nieuwe SSH-key is exact hetzelfde als een al toegevoegde SSH-key",
		description:
			"Selecteer welke gebruikers (met SSH-keys) toegang hebben tot de VPS, en/of voeg handmatig SSH-keys toe. Er wordt dan <strong>geen</strong> wachtwoord aangemaakt. Zorg dus dat de SSH poort benaderbaar blijft. Als u geen SSH-keys toevoegt, wordt er een wachtwoord aangemaakt waarmee u kan inloggen. Dit wachtwoord is te vinden op de VPS info-pagina, waar deze 30 dagen wordt getoond (sla dit wachtwoord dus zorgvuldig op!).",
		engineer_keys_obliged: `Omdat u een SLA heeft geselecteerd, moet ${company_name} toegang hebben tot uw VPS.`,
		external_keys: "Wilt u extra SSH-keys van een externe partij toevoegen?",
		no_own_keys_top: "U heeft geen SSH-keys toegevoegd aan uw account.",
		title: "VPS toegang",
		user_ssh_keys: {
			no_users_found: "Geen gebruikers met SSH-keys gevonden.",
			title: "SSH-keys van andere gebruikers toevoegen",
			users: "Gebruikers",
		},
	},
	template_items_disabled_message:
		"Er zijn één of meerdere configuratieopties voor dit VPS-template uitgeschakeld door Tuxis. Deze uitgeschakelde configuratieopties kunnen niet aangepast worden.",
	title: "VPS configurator",
};

export default configurator;
